<template>
    <div class="profile-page">
        <section class="section-profile-cover section-shaped my-0">
            <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </section>
        <section class="section section-skew">
            <div class="container">
                <card shadow class="card-profile mt--300" no-body>
                    <div class="px-4">
                        <div class="text-center mt-5">
                            <h3>복리후생</h3>
                        </div>
                        <div class="mt-5 py-5 border-top">
                            <div class="box">
                                <div class="row">
                                    <div class="col-lg-6 mt-5">
                                        <div class="line-dot">
                                            <dl class="icon icon-shape mb-5 mr-3 icon-lg icon-shape-success shadow rounded-circle">
                                                <i class="fa">&#128176;</i>
                                            </dl>
                                            <dl>
                                                <dd><strong>유급휴가 및 경조금 지원</strong></dd>
                                                <dd>각종 경조사 시 경조유급휴가 및 경조금과 화환 지원</dd>
                                            </dl>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 mt-5">
                                        <div class="line-dot">
                                            <dl class="icon icon-shape mb-5 mr-3 icon-lg icon-shape-success shadow rounded-circle">
                                                <i class="fa">&#127942;</i>
                                            </dl>
                                            <dl>
                                                <dd><strong>포상제도</strong></dd>
                                                <dd>장기근속자 표창</dd>
                                                <dd>우수사원</dd>
                                                <dd>우수경영현장, 격려현장, 안전우수현장, 흑자현장</dd>
                                            </dl>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-6 mt-5">
                                        <div class="line-dot">
                                            <dl class="icon icon-shape mb-5 mr-3 icon-lg icon-shape-success shadow rounded-circle">
                                                <i class="fa">&#128137;</i>
                                            </dl>
                                            <dl>
                                                <dd><strong>종합건강검진</strong></dd>
                                                <dd>매년 1회 전문의료기관에 위탁하여 정밀 건강검진 실시</dd>
                                            </dl>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 mt-5">
                                        <div class="line-dot">
                                            <dl class="icon icon-shape mb-5 mr-3 icon-lg icon-shape-success shadow rounded-circle">
                                                <i class="fa">&#127857;</i>
                                            </dl>
                                            <dl>
                                                <dd><strong>직원식당</strong></dd>
                                                <dd>직원들의 건강하고 여유로운 근무환경 조성을 위해 사내에 직원식당 운영</dd>
                                            </dl>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-6 mt-5">
                                        <div class="line-dot">
                                            <dl class="icon icon-shape mb-5 mr-3 icon-lg icon-shape-success shadow rounded-circle">
                                                <i class="fa">&#128138;</i>
                                            </dl>
                                            <dl>
                                                <dd><strong>단체상해보험</strong></dd>
                                                <dd>임직원 및 배우자의 불의의 질병 및 사고 시 경제적으로
                                                    지원하기 위하여 사망 및 재해, 암 진단/치료,
                                                    중대질병 진단/치료, 기타 일반 입원비 지원                                                    
                                                </dd>
                                            </dl>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 mt-5">
                                        <div class="line-dot">
                                            <dl class="icon icon-shape mb-5 mr-3 icon-lg icon-shape-success shadow rounded-circle">
                                                <i class="fa">&#128296;</i>
                                            </dl>
                                            <dl>
                                                <dd><strong>근무복 지급</strong></dd>
                                                <dd>현장 부임 시 근무복 지급</dd>
                                            </dl>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-6 mt-5">
                                        <div class="line-dot">
                                            <dl class="icon icon-shape mb-5 mr-3 icon-lg icon-shape-success shadow rounded-circle">
                                                <i class="fa">&#127881;</i>
                                            </dl>
                                            <dl>
                                                <dd><strong>창립기념일 선물 지급</strong></dd>
                                            </dl>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
    </div>
</template>
<script>
export default {};
</script>
<style>
.line-dot{
    display: flex;
    border-top-width: 0px;
    border-right-width: 0px;
    border-left-width: 0px;
    border-bottom: 1px black;
    border-style: dashed;
    height: 100%;
}

.line-dot > .icon > i {
    width: 64px;
}
</style>
